module.exports = __webpack_public_path__ + "static/media/ME_1.2ee365dd.jpg";